import React from "react"
import PropTypes from "prop-types"

import { searchifySelectGenericFilter, toggleGenericFilter } from "shared/search/containers/Filter/FilterCreators"

import { IssueManagementFilterableListView } from "shared/search/containers/FilterableListView/FilterableListViews"
import { IssueManagementSelect } from "app/static/frontend/selects/containers/PieSelect"

export const IssueManagementIssueTypeFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
IssueManagementIssueTypeFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
}
IssueManagementIssueTypeFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "issueManagementIssueTypeFilterGroup",
    filterKey: "parent__isnull",
    displayLabel: "Issue Type",
    trueText: "Primary",
    falseText: "Sub-issue",
}

export const IssueManagementIssueFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={IssueManagementFilterableListView} {...props} />
}
IssueManagementIssueFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
IssueManagementIssueFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "issueManagementIssueFilter",
    filterKey: "about_issue",
    dataTypeLabel: "Issues",
    displayLabel: "Sub-issues of",
    selectComponent: IssueManagementSelect,
}
